import { WawiSettings, WawiType } from "../../../../commons/types/wawi";

export const selectWawiTypeName = (
  wawiSettings: Partial<WawiSettings>,
  wawiTypeLabelMap: { [key in WawiType]: string }
) => {
  return (wawiSettings.type && wawiTypeLabelMap[wawiSettings.type]) ?? wawiSettings.type ?? "";
};
